import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { RoutingService } from '@skylab-angular-shared/core';
import { ConfirmationDialogInsComponent } from './confirmation-dialog-ins.component';

import { ComponentRef, ModalOptions } from '@inscomponents/core';
import { CommonKeys } from '../utils/common-keys';
import { ModalController } from '../wc-controllers/modal.controller';
import { ConfirmationDialogOptions, DialogResolution, DialogState } from './dialog.model';

@Injectable({providedIn: 'root'})
export class DialogInsService {
    public keyAction$ = new Subject<DialogState>();
    private keysHandler?: () => void;

    public constructor(
        private readonly modalController: ModalController,
        private readonly routingService: RoutingService
    ) {
        this.init();
    }

    private init() {
        this.routingService.states$.subscribe(async _ => {
            const top = await this.modalController.getTop();
            top?.dismiss({state: DialogState.Cancel});
        });
    }

    public async showAsync<TIn, TOut>(props: ModalOptions<ComponentRef, TIn>): Promise<DialogResolution<TOut>> {
        const modalData: ModalOptions<any, any> = {
            cssClass: 'modal--regular',
            backdropDismiss: false,
            ...props
        };

        const modal = await this.modalController.create(modalData);
        await modal.present();

        this.keysHandler?.();
        this.keysHandler = CommonKeys.add({
            ctrlEnter: () => { this.keyAction$.next(DialogState.Confirm); },
            esc: () => { this.keyAction$.next(DialogState.Cancel); }
        });

        const res = await modal.onDidDismiss<DialogResolution<TOut>>();
        return res.data ?? { state: DialogState.Cancel } as DialogResolution<TOut>;
    }

    public async showConfirmAsync(props: ConfirmationDialogOptions): Promise<DialogResolution> {
        return await this.showAsync({component: ConfirmationDialogInsComponent, componentProps: props});
    }

    public close<TOut>(data: DialogResolution<TOut>): void {
        this.keysHandler?.();
        this.modalController.dismiss(data);
    }
}
